<ng-container *ngIf="!init; else displayPopup">
  <mat-spinner class="init-spinner" color="primary" diameter="48"></mat-spinner>
</ng-container>

<ng-template #displayPopup>
  <ng-container *ngIf="subProject != null">
    <div class="project-info">
      <div class="image-container">
        <div
          *ngIf="subProject.firstAssetStyle != null"
          class="first-image clickable"
          [ngStyle]="subProject.firstAssetStyle"
          (click)="openLightbox()"
        ></div>
        <div
          *ngIf="subProject.firstAssetStyle == null"
          class="empty-image"
        ></div>
      </div>
      <div
        class="d-flex"
        [ngClass]="subProject.firstAssetStyle != null ? 'upper-space' : ''"
      >
        <div class="info-padding">
          <div *ngFor="let company of involvedCompanies">
            <span class="strong larger-font">{{ company }}</span>
          </div>
        </div>
        <div
          class="strong larger-font clickable smaller-left-space"
          [routerLink]="['/job', subProject.project.id, subProject.id]"
        >
          <span class="secondary-color">#{{ subProject.project.id }}</span>
          <span
            *ngIf="subProject.project.oldPlatformId != null"
            class="font-italic"
            [matTooltip]="'Jobnummer oud platform'"
          >
            ({{ subProject.project.oldPlatformId }})</span
          >
        </div>
      </div>
      <div
        class="smaller-upper-space type-display-banner"
        [ngClass]="subProject.typeClass"
      >
        <div>
          {{ subProject.typeDisplay }}
          <span class="normal">
            ({{ subProject.currentCreatedAt | date : 'dd/MM/yyyy' }})
          </span>
        </div>
      </div>
      <div
        *ngIf="subProject.project?.products?.length > 0"
        class="info-padding smaller-upper-space"
      >
        <div *ngFor="let product of subProject.project.products">
          <span class="strong">{{ product.overviewFormat }}</span>
        </div>
      </div>
      <div class="info-padding">
        {{
          subProject.address.line1
            | printAddress
              : subProject.address.postalCode
              : subProject.address.city
        }}
      </div>
      <div
        *ngIf="
          subProject.placementFloor != null &&
          subProject.placementFloor.length > 0
        "
        class="info-padding"
      >
        Verdieping: {{ subProject.placementFloor }}
      </div>
      <div
        *ngIf="
          subProject.adjustmentInfo != null &&
          subProject.adjustmentInfo.length > 0
        "
        class="info-padding upper-space font-weight-normal"
      >
        <b *ngIf="subProject.type === 'Adjustment'">Aanpassing: </b>
        {{ subProject.adjustmentInfo }}
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="immoTask != null">
    <div class="project-info">
      <div class="image-container">
        <div
          *ngIf="immoTask.firstAssetStyle != null"
          class="first-image clickable"
          [ngStyle]="immoTask.firstAssetStyle"
          (click)="openLightbox()"
        ></div>
        <div *ngIf="immoTask.firstAssetStyle == null" class="empty-image"></div>
      </div>
      <div
        class="d-flex"
        [ngClass]="immoTask.firstAssetStyle != null ? 'upper-space' : ''"
      >
        <div class="info-padding">
          <div>
            <span class="strong larger-font">{{
              immoTask.requestingUser?.firstName
                | personName : immoTask.requestingUser?.lastName
            }}</span>
          </div>
        </div>
        <div
          class="strong larger-font clickable smaller-left-space"
          (click)="openTaskEditModal()"
        >
          <span class="secondary-color">#{{ immoTask.id }}</span>
        </div>
      </div>
      <div class="smaller-upper-space type-display-banner immo-task-type">
        <div>Taak</div>
      </div>
      <div class="info-padding smaller-upper-space">
        <div>
          <span class="strong">{{ immoTask.subject }}</span>
        </div>
      </div>
      <div class="info-padding">
        {{
          immoTask.address?.line1
            | printAddress
              : immoTask.address?.postalCode
              : immoTask.address?.city
        }}
      </div>
    </div>
  </ng-container>
  <div class="upper-space">
    <mat-form-field
      appearance="outline"
      class="normalize-select font-16 tour-date-picker"
      [ngClass]="
        subProject?.currentRequestDate != null ||
        immoTask?.requestedDate != null
          ? 'date-picker-warning'
          : ''
      "
      [matTooltip]="'Kan niet bewerken, is locked'"
      [matTooltipDisabled]="!locked"
    >
      <input
        matInput
        [min]="today"
        [matDatepicker]="selectedTourDatePicker"
        placeholder="Selecteer een datum"
        [(ngModel)]="selectedTourDate"
        (ngModelChange)="selectedTourDateChanged()"
        [disabled]="locked"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="selectedTourDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #selectedTourDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div *ngIf="placerOptions?.length > 0" class="smaller-upper-space">
    <mat-form-field
      class="normalize-select font-14"
      appearance="outline"
      [matTooltip]="'Kan niet bewerken, is locked'"
      [matTooltipDisabled]="!locked"
    >
      <mat-select
        matInput
        placeholder="Kies een installateur"
        [(ngModel)]="selectedPlacer"
        name="placer"
        [compareWith]="compareEntities"
        [disabled]="locked"
      >
        <mat-option *ngFor="let option of placerOptions" [value]="option">
          <span>{{
            option.user?.firstName | personName : option.user?.lastName
          }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="smaller-upper-space">
    <div
      class="value-display"
      [ngClass]="
        subProject?.currentRequestDate != null || immoTask?.currentRequestDate
          ? 'value-display-warning'
          : ''
      "
    >
      <div class="text-display">
        <ng-container *ngIf="subProject != null">
          <span>{{
            subProject.currentRequestDate
              | printASAPDateFormat
                : subProject.currentRequestASAP
                : 'dd-MM-yyyy'
          }}</span>
        </ng-container>
        <ng-container *ngIf="immoTask != null">
          <span>{{
            immoTask.currentRequestDate
              | printASAPDateFormat : immoTask.currentRequestASAP : 'dd-MM-yyyy'
          }}</span>
        </ng-container>
      </div>
      <div class="icon-display">
        <mat-icon
          *ngIf="
            subProject?.currentRequestDate != null ||
              immoTask?.requestedDate != null;
            else emptySpan
          "
          >event</mat-icon
        >
        <ng-template #emptySpan>
          <span class="empty-span">&nbsp;</span>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="small-upper-space actions-container">
    <ng-container *ngIf="!submitting; else spinner">
      <div
        [matTooltip]="'Kan niet bewerken, is locked'"
        [matTooltipDisabled]="!locked"
      >
        <button
          class="plan-button unassign-button"
          mat-button
          type="button"
          (click)="replanItem(true)"
          [disabled]="locked"
        >
          Losmaken
        </button>
      </div>
      <div
        class="d-flex"
        [matTooltip]="'Kan niet bewerken, is locked'"
        [matTooltipDisabled]="!locked"
      >
        <button
          class="plan-button"
          [ngClass]="
            subProject?.currentRequestDate != null ||
            immoTask?.requestedDate != null
              ? 'date-button'
              : 'asap-button'
          "
          mat-button
          type="button"
          [disabled]="selectedPlacer == null || locked"
          (click)="replanItem(false)"
        >
          Wijzig
        </button>
        <div class="lock-checkbox">
          <mat-checkbox [ngModel]="locked" (ngModelChange)="updateLock()"
            >LOCK</mat-checkbox
          >
        </div>
      </div>
    </ng-container>
    <ng-template #spinner>
      <mat-spinner color="primary" diameter="24"></mat-spinner>
    </ng-template>
  </div>
</ng-template>
